import { NgModule } from '@angular/core';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { DxTreeListModule } from 'devextreme-angular/ui/tree-list';

// Centralized DevExtreme module for better tree shaking
// Only import the specific modules that are actually used
const DEVEXTREME_MODULES = [
  DxDataGridModule,
  DxTreeListModule
];

@NgModule({
  imports: DEVEXTREME_MODULES,
  exports: DEVEXTREME_MODULES
})
export class DevExpressModule {}
